import { render, staticRenderFns } from "./UserPersonalCardUpdate.vue?vue&type=template&id=6d03f109&"
import script from "./UserPersonalCardUpdate.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports